module.exports = __webpack_public_path__ + "static/media/bone-break.11c6dcba.svg";